import { TestIdDomain } from 'constants/testIds';

const LoginTestIdsScope = {
  JWT_FORM: 'jwt-login-form',
  OTP_FORM: 'otp-login-form',
  PASSKEY: 'passkey-login',
  SET_PASSWORD_FORM: 'set-password-form',
};

export const LoginTestIds = {
  // Login.js / JWTLoginTab.js — shared primary sign-in button
  LOGIN_BUTTON: `${TestIdDomain.COMMON}.login-button`,

  // JWTLoginTab.js
  JWT_FORM: LoginTestIdsScope.JWT_FORM,
  JWT_USERNAME_INPUT: `${LoginTestIdsScope.JWT_FORM}.username-input`,
  JWT_PASSWORD_INPUT: `${LoginTestIdsScope.JWT_FORM}.password-input`,
  JWT_ERROR_MESSAGE: `${LoginTestIdsScope.JWT_FORM}.error-message`,
  JWT_NOTICE_MESSAGE: `${LoginTestIdsScope.JWT_FORM}.notice-message`,
  JWT_EMAIL_CODE_LINK: `${LoginTestIdsScope.JWT_FORM}.email-code-link`,
  JWT_BACK_TO_PASSWORD: `${LoginTestIdsScope.JWT_FORM}.back-to-password-link`,

  // OtpLoginTab.js
  OTP_CODE_INPUT: `${LoginTestIdsScope.OTP_FORM}.code-input`,
  OTP_REMEMBER_DEVICE_CHECKBOX: `${LoginTestIdsScope.OTP_FORM}.remember-device-checkbox`,
  OTP_VERIFY_BUTTON: `${LoginTestIdsScope.OTP_FORM}.verify-button`,
  OTP_BACK_BUTTON: `${LoginTestIdsScope.OTP_FORM}.back-button`,

  // PasskeyLoginTab.js
  PASSKEY_SIGN_IN_BUTTON: `${LoginTestIdsScope.PASSKEY}.sign-in-button`,
  PASSKEY_USE_PASSWORD_BUTTON: `${LoginTestIdsScope.PASSKEY}.use-password-button`,
  PASSKEY_ERROR_MESSAGE: `${LoginTestIdsScope.PASSKEY}.error-message`,

  // SetInitialPasswordTab.js
  SET_PASSWORD_NEW_INPUT: `${LoginTestIdsScope.SET_PASSWORD_FORM}.new-password-input`,
  SET_PASSWORD_CONFIRM_INPUT: `${LoginTestIdsScope.SET_PASSWORD_FORM}.confirm-password-input`,
  SET_PASSWORD_SUBMIT_BUTTON: `${LoginTestIdsScope.SET_PASSWORD_FORM}.submit-button`,
};
